import { createSlice } from "@reduxjs/toolkit";
import { postIntake } from "services/intake/intake";

const initialState = {
    intake : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}

export const saveIntakeSlice = createSlice({
    name: 'saveIntake',
    initialState,
    extraReducers: {
        [postIntake.pending]: (state) => {
            state.intake.isLoading = true;
        },
        [postIntake.fulfilled]: (state, { payload }) => {
            state.intake.isLoading = false;
            state.intake.isSuccess = true;
            state.intake.data = payload;
        },
        [postIntake.rejected]: (state, { payload }) => {
            state.intake.isLoading = false;
            state.intake.isSuccess = false;
            state.intake.errorMessage = payload
        }
    }
})

export default saveIntakeSlice.reducer;